var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaelcorp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 231 102.861",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_95",
    "data-name": "Groupe 95",
    transform: "translate(-12.856)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_18",
    "data-name": "Groupe 18",
    transform: "translate(61.654 20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2",
    "data-name": "Groupe 2",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M0,47.165V25.14a1.914,1.914,0,0,1,.964-1.662L41.6.255a1.914,1.914,0,0,1,2.864,1.662V23.459a1.914,1.914,0,0,1-.95,1.654L2.879,48.819A1.914,1.914,0,0,1,0,47.165",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M130.216,47.165V25.14a1.915,1.915,0,0,1,.964-1.662L171.821.255a1.914,1.914,0,0,1,2.864,1.662V23.459a1.914,1.914,0,0,1-.95,1.654l-40.64,23.707a1.914,1.914,0,0,1-2.879-1.654",
    transform: "translate(-85.748 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M260.432,47.165V25.14a1.914,1.914,0,0,1,.964-1.662L302.036.255A1.914,1.914,0,0,1,304.9,1.917V23.459a1.914,1.914,0,0,1-.95,1.654l-40.64,23.707a1.914,1.914,0,0,1-2.879-1.654",
    transform: "translate(-171.495 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaelcorp);
export default __webpack_public_path__ + "static/media/maelcorp.9f0a635ccc52e620295382c378e31ab6.svg";
export { ForwardRef as ReactComponent };